module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('button', {
    staticClass: "fullBtn",
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": require('../../assets/svg/googleicon.svg').default
    }
  }), _vm._v("\n    " + _vm._s(_vm.$t("user.loginButton.button")) + "\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cd62283","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/googleButton.vue
// module id = 270
// module chunks = 0 12 13 15